@if (isBitFlagEnum) {
  <mat-form-field>
    <mat-label>{{field.Name}}</mat-label>
    <mat-select [placeholder]="field.Name" multiple [formControl]="mainControl">
      <mat-option [value]="undefined">-</mat-option>
      @for (enumField of enumFields; track enumField) {
        <mat-option [value]="enumField.value">{{ enumField.label }} ({{enumField.value}})</mat-option>
      }
    </mat-select>
    @if (field.Deprecation) {
      <mat-hint class="d-flex align-items-stretch">
        <mat-icon class="warning mr-1">warning</mat-icon>
        <span [matTooltip]="field.Deprecation">This field is deprecated, hover for more info</span>
      </mat-hint>
    }
    @if (field.Description && !field.Deprecation) {
      <mat-hint class="d-flex align-items-stretch">
        <mat-icon class="mr-1">info</mat-icon>
        <span [matTooltip]="field.Description">Hover for field description</span>
      </mat-hint>
    }
  </mat-form-field>
}
@if (!isBitFlagEnum) {
  <mat-form-field>
    <mat-label>{{field.Name}}</mat-label>
    <mat-select [placeholder]="field.Name" [formControl]="mainControl">
      <mat-option [value]="undefined">-</mat-option>
      @for (enumField of enumFields; track enumField) {
        <mat-option [value]="enumField.value">{{ enumField.label }} ({{enumField.value}})</mat-option>
      }
    </mat-select>
    @if (field.Deprecation) {
      <mat-hint class="d-flex align-items-stretch">
        <mat-icon class="warning mr-1">warning</mat-icon>
        <span [matTooltip]="field.Deprecation">This field is deprecated, hover for more info</span>
      </mat-hint>
    }
    @if (field.Description && !field.Deprecation) {
      <mat-hint class="d-flex align-items-stretch">
        <mat-icon class="mr-1">info</mat-icon>
        <span [matTooltip]="field.Description">Hover for field description</span>
      </mat-hint>
    }
  </mat-form-field>
}
